import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXeroComponent } from './simple-icons-xero.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXeroComponent ],
    exports:      [ SimpleIconsXeroComponent ],
    bootstrap:    []
})
export class SimpleIconsXeroModule {}
